import React, { useState, useContext, useEffect } from "react";
import {
  Grid,
  Button,
  Typography,
  TextField,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Context } from "../store";
import { modify_AppointmentDetails } from "../actions";
import useStyles from "../css/styles";
import FilterPage from "../inoffice/appointmentFilter";
import { useHistory } from "react-router-dom";
import { GetInsuranceCarriers, GetInsurancePlans, InsertPELogs } from "../api"; //FB 4960
import globalsettings from "../../../config"; //FB 4960

// update log
// FB 4371 DK    03/29/2021    Added for Insurance module in home page
// FB 4574 DK    07/15/2021    Added styling for dropdown icon
// FB 4735 DK    10/11/2021    implementation of provider specific workflow
// FB 4949 DK    02/11/2022    Enable/Disable insurance selection
// FB 4960 BR    07/03/2022   Logging all actions on PE
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time

export default function ProviderComponent(props: any) {
  const { state, dispatch } = useContext(Context);
  const [isInsuranceExist, setIsInsuranceExist] = useState(
    state.appointmentdetails.isInsuranceExist
  );
  const [insurancelist, setInsuranceList] = useState([]);
  const [insurance, SetInsurance] = useState({
    name: state.appointmentdetails.insurance.name,
    id: state.appointmentdetails.insurance.id,
  });
  const [insuranceplanlist, SetInsurancePlanlist] = useState([]);
  const [insuranceplan, SetInsurancePlan] = useState({
    name: state.appointmentdetails.insurance.planName,
    id: state.appointmentdetails.insurance.planId,
  });
  const styles = useStyles();

  //FB 4371 DK    Added to load the insurance list
  useEffect(() => {
    GetInsuranceCarriers().then((data) => {
      setInsuranceList(data);
    });
  }, []);

  //FB 4371 DK    Added to get plans for selected insurance
  useEffect(() => {
    if (state.appointmentdetails.insurance.planId === 0) {
      SetInsurancePlan({ id: 0, name: "" });
    }
    GetInsurancePlans(insurance.id).then((data) => {
      SetInsurancePlanlist(data);
    });
  }, [insurance]);

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });

  //FB 4371 DK    Added to modify the state when isinsuranceexist value is updated
  const handleClick = (value: string) => {
    setIsInsuranceExist(value);
    //FB 4960 Start
    if (value == "No") {
      InsertPELogs(globalsettings.clientIp, "Selected No insurance");
    }
    else if (value == "Yes") {
      InsertPELogs(globalsettings.clientIp, "Selected Choose insurance");
    }
    //FB 4960 End
    modify_AppointmentDetails(
      {
        appointmenttype: state.appointmentdetails.appointmenttype,
        customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
        patientType: state.appointmentdetails.patientType,
        isInsuranceExist: value,
        insurance: state.appointmentdetails.insurance,
        appointmentfilter: "",
        provider: state.appointmentdetails.provider,
        location: state.appointmentdetails.location,
        date: new Date(),
      },
      dispatch
    );
  };

  //FB 4371 DK    Added to modify the state when insurance is selected
  const insuranceChange = (event: any, value: any) => {
    if (value != null) {
      SetInsurance(value);
      modify_AppointmentDetails(
        {
          appointmenttype: state.appointmentdetails.appointmenttype,
          customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
          patientType: state.appointmentdetails.patientType,
          isInsuranceExist: state.appointmentdetails.isInsuranceExist,
          insurance: {
            id: value.id,
            planId: 0,
            name: value.name,
            planName: "",
          },
          appointmentfilter: "",
          provider: state.appointmentdetails.provider,
          location: state.appointmentdetails.location,
          date: new Date(),
        },
        dispatch
      );
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Selected insurance " + value.name);
      //FB 4960 End
    } else {
      SetInsurance({
        name: "",
        id: 0,
      });
    }
  };

  //FB 4371 DK    Added to modify the state when insurance plan is selected
  const insuranceplanChange = (event: any, value: any) => {
    if (value != null) {
      SetInsurancePlan(value);
      modify_AppointmentDetails(
        {
          appointmenttype: state.appointmentdetails.appointmenttype,
          customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
          patientType: state.appointmentdetails.patientType,
          isInsuranceExist: state.appointmentdetails.isInsuranceExist,
          insurance: {
            id: state.appointmentdetails.insurance.id,
            planId: value.id,
            name: state.appointmentdetails.insurance.name,
            planName: value.name,
          },
          appointmentfilter: "",
          provider: state.appointmentdetails.provider,
          location: state.appointmentdetails.location,
          date: new Date(),
        },
        dispatch
      );
    } else {
      SetInsurancePlan({
        name: "",
        id: 0,
      });
    }
  };


  function handleGoback() {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Insurance Carrier");
    //FB 4960 End
    props.onCallbackType("");
  }

  //FB 4371 DK    Added to load the next option based on the insurance selection
  function getcomponent() {
    if (isInsuranceExist === "Yes" && state.defaultlocation.id === 0) {
      //if (insuranceplan.id > 0 && insurance.id > 0) {
      if (insurance.id > 0) {
        //if(insurance.name==='OTHER'||insuranceplan.id>0)
        //if(insurance.name==='OTHER')
        return (
          // FB 4949
          <FilterPage
            origin="InsuranceCarrier"
            onCallback={setIsInsuranceExist}
            insurance={SetInsurance}
            insuranceplan={SetInsurancePlan}
          />
        );
      }
    } else if (isInsuranceExist === "No" && state.defaultlocation.id === 0) {
      return (
        // FB 4949
        <FilterPage
          origin="InsuranceCarrier"
          onCallback={setIsInsuranceExist}
          insurance={SetInsurance}
          insuranceplan={SetInsurancePlan}
        />
      );
    }
  }

  const history = useHistory();
  //FB 4735 DK - Added condition to differentiate between location and provider specific flows
  //FB 4960
  const handleProceed = () => {
    if (state.defaultlocation.id > 0) {
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on Show Schedule - by office location");
      //FB 4960 End
      history.push("/slots_bylocation", state);
    }
    else {
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on Show Schedule - by provider");
      //FB 4960 End
      history.push("/slots_byprovider", state);
    }
  };

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div ref={scrollTo}>
      <Grid container spacing={2} direction="row">
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6">Please choose your insurance</Typography>
        </Grid>
        <Grid
          item
          xs={8}
          sm={4}
          md={3}
          lg={3}
          style={{
            display: isInsuranceExist === "Yes" ? "none" : "inline-flex",
          }}
        >
          <Button
            variant="outlined"
            id="noInsurance"
            onClick={() => handleClick("No")}
            className={
              isInsuranceExist === "No"
                ? styles.buttonActive
                : styles.buttonInactive
            }
          >
            No insurance
          </Button>
        </Grid>
        <Grid
          item
          xs={8}
          sm={4}
          md={3}
          lg={3}
          style={{
            display: isInsuranceExist === "No" ? "none" : "inline-flex",
          }}
        >
          <Button
            variant="outlined"
            id="chooseInsurance"
            onClick={() => handleClick("Yes")}
            className={
              isInsuranceExist === "Yes"
                ? styles.buttonActive
                : styles.buttonInactive
            }
          >
            Choose insurance
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        direction="row"
        style={{
          display: isInsuranceExist === "Yes" ? "inline-flex" : "none",
        }}
      >
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="insurancelist"
              fullWidth
              onChange={insuranceChange}
              value={insurance}
              getOptionLabel={(option) => option.name}
              options={insurancelist}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              // FB 4574 DK - Added styling for icon
              classes={{
                popupIndicator: styles.autocompleteIcon
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Insurance"
                  variant="standard"
                  margin="normal"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        direction="row"
        style={{
          display:
            isInsuranceExist === "Yes" &&
              insurance.id > 0 &&
              insurance.name != "OTHER"
              ? "inline-flex"
              : "none",
        }}
      >
        {/* <Grid item xs={12} sm={6} md={6} lg={4}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="insuranceplanlist"
              fullWidth
              onChange={insuranceplanChange}
              value={insuranceplan}
              getOptionLabel={(option) => option.name}
              options={insuranceplanlist}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Insurance Plan (optional)"
                  variant="standard"
                  margin="normal"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid> */}
      </Grid>

      <Grid
        container
        spacing={2}
        className={styles.flexend_Grid}
        style={{
          display:
            isInsuranceExist === "No" ||
              (isInsuranceExist && state.appointmentdetails.insurance.id > 0)
              ? "none"
              : "flex",
        }}
      >
        <Grid item xs={6} sm={4} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            id="goBackInsurance"
            onClick={() => {
              isInsuranceExist === "Yes"
                ? setIsInsuranceExist("")
                : handleGoback();
            }}
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
      {/* FB 4735 DK - Modified condition */}
      {(isInsuranceExist === "No" && (state.defaultlocation.id > 0 || state.defaultprovider.id > 0)) ||
        ((isInsuranceExist === "Yes" && (state.defaultlocation.id > 0 || state.defaultprovider.id > 0))
          && (state.appointmentdetails.insurance.id > 0 || state.appointmentdetails.insurance.name === "OTHER")) ? (
        <Grid
          container
          spacing={2}
          className={styles.flexend_Grid}
          style={{ marginTop: "5%" }}
        >
          <Grid
            item
            xs={6}
            sm={4}
            md={2}
            lg={2}
            className={styles.flexend_Grid}
          >
            <Button
              variant="contained"
              className={styles.navigationButton}
              id="showScheduleInsurance"
              onClick={handleProceed}
            >
              Show Schedule
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={2}
            lg={2}
            className={styles.flexend_Grid}
          >
            <Button
              onClick={() => {
                setIsInsuranceExist("");
                SetInsurance({ id: 0, name: "" });
                SetInsurancePlan({ id: 0, name: "" });
              }}
              variant="contained"
              className={styles.navigationButton}
            >
              Go Back
            </Button>
          </Grid>
        </Grid>
      ) : (
        <React.Fragment>{getcomponent()}</React.Fragment>
      )}
    </div>
  );
}
